export default __webpack_public_path__ + "static/media/momentum-device.0898eb7d.svg";